import React, { useEffect, useRef, useState } from 'react';
import PublicNav from './PublicNav';
import PublicFooter from './PublicFooter';
import { C, container } from './publicStyles';
import { useAuth } from '../../context/AuthContext';
import { lookupMembership, claimMembership } from '../../firebase/orgs';

const MAX_ATTEMPTS = 40; // ~2 minutes at 3s

export default function SignupCompletePage({ pollIntervalMs = 3000 }) {
  const { user } = useAuth() || {};
  const [timedOut, setTimedOut] = useState(false);
  const attempts = useRef(0);

  useEffect(() => {
    if (!user?.email) return undefined;
    let cancelled = false;
    const tick = async () => {
      if (cancelled) return;
      attempts.current += 1;
      try {
        const membership = await lookupMembership(user.email);
        if (membership?.orgId) {
          await claimMembership(membership.orgId, user.email, user.uid);
          window.location.assign('/');   // full reload re-runs AuthProvider provisioning
          return;
        }
      } catch (_) { /* keep polling; webhook may still be processing */ }
      if (attempts.current >= MAX_ATTEMPTS) { setTimedOut(true); return; }
      setTimeout(tick, pollIntervalMs);
    };
    tick();
    return () => { cancelled = true; };
  }, [user, pollIntervalMs]);

  return (
    <div style={{ minHeight: '100vh', background: C.bg, display: 'flex', flexDirection: 'column' }}>
      <PublicNav />
      <main style={{ ...container, flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '64px 24px' }}>
        <div style={{ background: C.panel, border: `1px solid ${C.border}`, borderRadius: 14, padding: '40px 36px', maxWidth: 480, textAlign: 'center' }}>
          {!user ? (
            <p style={{ color: C.muted, fontSize: 14, margin: 0 }}>Sign in to finish setting up your workspace.</p>
          ) : timedOut ? (
            <>
              <h1 style={{ color: C.text, fontWeight: 800, fontSize: '1.3rem', marginBottom: 10 }}>Payment received</h1>
              <p style={{ color: C.muted, fontSize: 14, margin: 0 }}>
                Provisioning is taking longer than usual. Your workspace will appear shortly;
                if it does not, email <span style={{ color: C.info }}>support@crimsonscan.com</span> and we will fix it fast.
              </p>
            </>
          ) : (
            <>
              <h1 style={{ color: C.text, fontWeight: 800, fontSize: '1.3rem', marginBottom: 10 }}>Setting up your workspace</h1>
              <p style={{ color: C.muted, fontSize: 14, margin: 0 }}>Payment confirmed. This usually takes a few seconds.</p>
            </>
          )}
        </div>
      </main>
      <PublicFooter />
    </div>
  );
}
